module.exports = __webpack_public_path__ + "img/kungfu-legend.0913abb.png";